import { OidcProvider } from "@axa-fr/react-oidc";
import { FC, PropsWithChildren, useMemo } from "react";
import { OidcContext } from "../types/oidcTypes";
import { getOidcConfigurationForContext } from "../utils/oidcConfiguration";

export interface AuthContextProviderProps {
  oidcContext: OidcContext;
}

export const AuthContextProvider: FC<PropsWithChildren<AuthContextProviderProps>> = ({ children, oidcContext }) => {
  const configuration = useMemo(
    () => getOidcConfigurationForContext(oidcContext),
    [oidcContext],
  );

  return (
    <OidcProvider configurationName={oidcContext} configuration={configuration}>
      {children}
    </OidcProvider>
  );
};
